export default "__VITE_ASSET__DYpileHI__"